<template>
    <div class="discussion-history" :data-discussion-source="sourceKey" tabindex="-1">
        <template v-for="(part, index) in segments">
            <DiscussionText v-if="part.message" :key="index" :context="currentContext" :value="part.message.body"
                :source-type="sourceType" :source-id="sourceId" :field-key="part.message.message_ref.field_key" :supplied="part.message" />
            <blockquote v-else-if="part.quote" :key="index" class="user-quote" v-html="linkify(part.text)"></blockquote>
            <span v-else :key="index" class="discussion-history__system" v-html="linkify(part.text)"></span>
        </template>
        <div v-if="error" role="alert" class="small text-danger">{{ error }} <button type="button" @click="load">Повторить</button></div>
    </div>
</template>
<script>
import DiscussionText from './DiscussionText.vue';
import linkify from '@/utils/Urlify';
import {readMessage, discussionContextMixin} from '@/utils/discussions';
const {messageKey} = require('../../../../shared/discussionText');
export default {
    name: 'DiscussionHistory', components: {DiscussionText}, mixins: [discussionContextMixin],
    props: {value: {type: String, default: ''}, sourceType: String, sourceId: [String, Number], fallbackBlocks: Array},
    data: () => ({messages: [], version: 0, error: ''}),
    computed: {
        sourceKey() { return messageKey(this.reference, true); },
        reference() { return this.currentContext && {context_type: this.currentContext.type, context_id: this.currentContext.id, source_type: this.sourceType, source_id: Number(this.sourceId), field_key: 'body'}; },
        segments() {
            if (!this.messages.length && this.fallbackBlocks) return this.fallbackBlocks.map(part => ({text: part.text, quote: part.kind !== 'system'}));
            let result = [{text: this.value}];
            this.messages.forEach(message => {
                let found = false;
                result = result.reduce((parts, part) => {
                    const at = !part.message && !found ? part.text.indexOf(message.body) : -1;
                    if (at < 0) parts.push(part);
                    else { found = true; parts.push({text: part.text.slice(0, at)}, {message}, {text: part.text.slice(at + message.body.length)}); }
                    return parts;
                }, []);
                if (!found) result.push({message});
            });
            return result;
        }
    },
    watch: {reference: {deep: true, immediate: true, handler() { this.load(); }}, value() { this.load(); }},
    beforeDestroy() { this.version++; },
    methods: {
        linkify,
        async load() {
            const version = ++this.version; this.messages = []; this.error = '';
            if (!this.reference) return;
            try { const result = await readMessage(this.reference, undefined, undefined, undefined, true); if (version === this.version) this.messages = result.parts || []; }
            catch (error) { if (version === this.version) this.error = 'Не удалось загрузить пояснения.'; }
        }
    }
};
</script>
<style scoped>
.discussion-history { min-width: 0; overflow-wrap: anywhere; }
.discussion-history__system { white-space: pre-wrap; }
</style>
